import React, { useState, useEffect, useMemo } from "react";
import { default as ReactSelect, components } from "react-select";
const Multi = (props) => {
    const [selectInput, setSelectInput] = useState("");
    const [selectedOptions, setSelectedOptions] = useState([]);
    useEffect(() => {
        setSelectedOptions(props.value);
    }, [props.value]);
    // Set maxSelection based on id
    const maxSelection = useMemo(() => {
        switch (props.id) {
            case "petrols-costs":
                return 6;
            case "petrols-energy":
            case "petrols-industry":
                return 4;
            case "year":
            case "area":
                return 5;
            default:
                return 6; // Default max selection
        }
    }, [props.id]);
    const comparator = (v1, v2) => {
        const value1 = typeof v1.value === "string" ? v1.value.toLowerCase() : v1.value;
        const value2 = typeof v2.value === "string" ? v2.value.toLowerCase() : v2.value;
        if (value1 < value2)
            return -1;
        if (value1 > value2)
            return 1;
        return 0;
    };
    const handleChange = (selected) => {
        if (Array.isArray(selected)) {
            const sortedSelected = selected.sort(comparator);
            if (selected.length <= maxSelection) {
                setSelectedOptions(sortedSelected);
                props.onChange(sortedSelected, props.id);
                setSelectInput("");
            }
        }
        else {
            if (props.id === "area") {
                props.setArea(selected);
            }
            setSelectedOptions([selected]);
            props.onChange([selected], props.id);
        }
    };
    const customStyles = {
        multiValueLabel: (def) => (Object.assign(Object.assign({}, def), { backgroundColor: "white", border: "1px solid gray", borderRight: "none" })),
        multiValueRemove: (def) => (Object.assign(Object.assign({}, def), { backgroundColor: "white", border: "1px solid gray", borderLeft: "none" })),
        valueContainer: (base) => (Object.assign(Object.assign({}, base), { maxHeight: "70px", overflow: "auto" })),
        option: (styles, { isSelected, isFocused }) => {
            return Object.assign(Object.assign({}, styles), { backgroundColor: isSelected && !isFocused
                    ? null
                    : isFocused && !isSelected
                        ? styles.backgroundColor
                        : isFocused && isSelected
                            ? "#DEEBFF"
                            : null, color: isSelected ? null : null, cursor: selectedOptions.length >= maxSelection && !isSelected
                    ? "not-allowed"
                    : "default" });
        },
        menu: (def) => (Object.assign(Object.assign({}, def), { zIndex: 9999 })),
    };
    const Input = (props) => {
        return (React.createElement(React.Fragment, null, selectInput.length === 0 ? (React.createElement(components.Input, Object.assign({ autoFocus: props.selectProps.menuIsOpen }, props), props.children)) : (React.createElement("div", null,
            React.createElement(components.Input, Object.assign({ autoFocus: props.selectProps.menuIsOpen }, props), props.children)))));
    };
    const Option = (props) => {
        const isDisabled = selectedOptions.length >= maxSelection && !props.isSelected;
        return (React.createElement(components.Option, Object.assign({}, props),
            props.value !== "*" && props.selectProps.isMulti ? (React.createElement("input", { key: props.value, type: "checkbox", checked: props.isSelected, onChange: () => { }, disabled: isDisabled })) : null,
            React.createElement("label", { style: {
                    marginLeft: props.selectProps.isMulti ? "5px" : "0",
                    pointerEvents: "none",
                    color: isDisabled ? "gray" : "inherit",
                } }, props.label)));
    };
    return (React.createElement(ReactSelect, Object.assign({}, props, { placeholder: "Wybierz opcje...", value: selectedOptions, inputValue: selectInput, onInputChange: (inputValue, { action }) => {
            if (action === "input-change")
                setSelectInput(inputValue);
            else if (action === "menu-close" && selectInput !== "")
                setSelectInput("");
        }, options: props.options, onChange: handleChange, components: { Input, Option }, styles: customStyles, isMulti: props.isMulti, closeMenuOnSelect: false, hideSelectedOptions: false, backspaceRemovesValue: false, blurInputOnSelect: false })));
};
export default Multi;
